// extracted by mini-css-extract-plugin
export var cardLayout = "_93-1";
export var paginationContainer = "_93-0";